import React, { useState, useMemo } from 'react';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Chip } from '@mui/material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PaySheetModal from './PaySheetModal';
import { formatReportPeriod, isTrainingOperator } from '../../format';

const OperatorPaySheets = ({ paySheetsData, classes }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedPaySheetId, setSelectedPaySheetId] = useState(null);

    // Сортируем данные по периоду (новые сверху)
    const paySheets = useMemo(() => {
        if (!paySheetsData || paySheetsData.length === 0) return [];
        return [...paySheetsData]
            .filter((sheet) => !isTrainingOperator(sheet))
            .sort((a, b) => {
                // Сортируем по периоду (формат "MM.YYYY")
                if (!a.period || !b.period) return 0;
                const [monthA, yearA] = a.period.split('.');
                const [monthB, yearB] = b.period.split('.');
                const dateA = new Date(parseInt(yearA), parseInt(monthA) - 1);
                const dateB = new Date(parseInt(yearB), parseInt(monthB) - 1);
                return dateB - dateA; // DESC
            })
            .slice(0, 10); // Берем только первые 10
    }, [paySheetsData]);

    const handleViewClick = (id) => {
        setSelectedPaySheetId(id);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedPaySheetId(null);
    };

    const getStatusColor = (status) => {
        const colors = {
            'Accepted': 'success',
            'Approved': 'success',
            'Advance': 'warning',
            'Draft': 'default'
        };
        return colors[status] || 'default';
    };

    return (
        <div className={classes.scheduleSection}>
            <Typography className={classes.sectionTitle}>
                <ReceiptIcon style={{ fontSize: 18, marginRight: 8, verticalAlign: 'middle' }} />
                Расчетные листы
            </Typography>
            {!paySheetsData || paySheets.length === 0 ? (
                <Typography style={{ color: '#666', fontSize: '14px', marginTop: 8 }}>
                    Нет расчетных листов
                </Typography>
            ) : (
                <TableContainer component={Paper} className={classes.paySheetTable}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.paySheetTableHeader}>Период</TableCell>
                                <TableCell className={classes.paySheetTableHeader}>Договор</TableCell>
                                <TableCell className={classes.paySheetTableHeader} align="right">Сумма</TableCell>
                                <TableCell className={classes.paySheetTableHeader} align="center">OCC %</TableCell>
                                <TableCell className={classes.paySheetTableHeader}>Версия мотивации</TableCell>
                                <TableCell className={classes.paySheetTableHeader} align="center">Статус</TableCell>
                                <TableCell className={classes.paySheetTableHeader} align="center">Действия</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paySheets.map((sheet) => (
                                <TableRow key={sheet._id || sheet.id} hover>
                                    <TableCell className={classes.paySheetTableCell}>
                                        {formatReportPeriod(sheet.period)}
                                    </TableCell>
                                    <TableCell className={classes.paySheetTableCell}>
                                        {sheet.calculation?.payoutKind === 'contract' || sheet.calculation?.contractType === 'Contract'
                                            ? `Контракт${sheet.calculation?.parttime === 'Half' ? ' · ½' : sheet.calculation?.parttime === 'Quarter' ? ' · ¼' : ''}`
                                            : (sheet.calculation?.contractType === 'Contractor' || sheet.calculation?.payoutKind === 'scheme' ? 'Подряд' : '—')}
                                    </TableCell>
                                    <TableCell className={classes.paySheetTableCell} align="right">
                                        <Typography style={{ fontWeight: 600, color: '#1976d2' }}>
                                            {sheet.summa ? `${parseFloat(sheet.summa).toFixed(2)} р` : '0.00 р'}
                                        </Typography>
                                    </TableCell>
                                    <TableCell className={classes.paySheetTableCell} align="center">
                                        {sheet.occPercent ? `${parseFloat(sheet.occPercent).toFixed(2)}%` : '0.00%'}
                                    </TableCell>
                                    <TableCell className={classes.paySheetTableCell}>
                                        {sheet.motivation?.version != null
                                            ? `v${sheet.motivation.version}${sheet.motivation.name ? ` · ${sheet.motivation.name}` : ''}`
                                            : sheet.motivationVersion?.version != null
                                                ? `v${sheet.motivationVersion.version}`
                                                : '—'}
                                    </TableCell>
                                    <TableCell className={classes.paySheetTableCell} align="center">
                                        {sheet.status && (
                                            <Chip 
                                                label={sheet.status} 
                                                color={getStatusColor(sheet.status)}
                                                size="small"
                                                className={classes.statusChip}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell className={classes.paySheetTableCell} align="center">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleViewClick(sheet._id || sheet.id)}
                                            color="primary"
                                        >
                                            <VisibilityIcon fontSize="small" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
            <PaySheetModal
                open={modalOpen}
                onClose={handleCloseModal}
                paySheetId={selectedPaySheetId}
            />
        </div>
    );
};

export default OperatorPaySheets;

